// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__25Quv","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3ErUF"};